import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { outreachMessages as messages } from '../outreachMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The fit score ring, 0 to 100 (design outreach c1, `fitScore.ts`). */
const FitRingComponent: React.FC<{ score: number }> = ({ score }) => {
  const intl = useIntl();
  const value = Math.max(0, Math.min(100, Math.round(score)));
  return (
    <span
      className={styles.fit}
      style={{ '--fit': value } as React.CSSProperties}
      aria-label={intl.formatMessage(messages.fit, { score: value })}
      role="img"
    >
      <span className={styles.fitValue}>{value}</span>
    </span>
  );
};

export const FitRing = TypedMemo(FitRingComponent);
